import React from "react";
import { Box, Grid, Link, TextField } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { rootClientPath } from "../../../util/link";
import { useSelectedBusiness } from "../../../redux/store";

const StaffProfile = (props: any) => {
  const selectedBusiness = useSelectedBusiness();
  const businessUrl = selectedBusiness?.businessBasic?.url || "";
  const staff = props.staff;

  return (
    <Grid container spacing={{ xs: 2, md: 3 }} sx={{ p: { xs: 1, md: 3 } }}>
      <Grid item xs={12} md={5}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name"
              variant="outlined"
              value={staff?.user?.username}
              disabled
              size="small"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", md: "1rem" },
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={staff?.user?.email}
              disabled
              size="small"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", md: "1rem" },
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Role"
              variant="outlined"
              value={staff?.role?.name}
              disabled
              size="small"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", md: "1rem" },
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column", // Force column layout so each item is on its own line
                alignItems: "stretch", // Ensure children take full width
                gap: 1,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  fontWeight: "bold",
                  color: "#888",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%", // Take full width
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                }}
              >
                {`${rootClientPath}/${businessUrl}/`}
              </Box>

              <TextField
                fullWidth
                label="Booking Link"
                variant="outlined"
                value={staff?.url || ""}
                disabled
                size="small"
                sx={{
                  "& .MuiInputBase-root": { pr: 0.5 },
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                    py: { xs: 0.5, md: 0.75 },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <Link
                      href={`${rootClientPath}/${businessUrl}/${staff?.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <OpenInNew
                        sx={{
                          fontSize: { xs: "1rem", md: "1.25rem" },
                          ml: 0.5,
                          cursor: "pointer",
                        }}
                      />
                    </Link>
                  ),
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StaffProfile;
